// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"4bda0cec","472":"4bda0cec","627":"e654acdc"}[chunkId] + ".chunk.css";
};